import { useQuery } from '@tanstack/react-query';

import { getAdminConversationCategoryList } from '@entities/AdminConversationCategory/api/handlers/getAdminConversationCategoryList';
import { ICategory } from '@entities/AdminConversationCategory/model/types';
import { keysToCamel } from '@shared/helpers';

export function useGetAdminConversationCategoryList() {
    const { data, isLoading, isPending } = useQuery({
        queryKey: ['adminConversationCategories'],
        queryFn: getAdminConversationCategoryList,
        select: (data) => keysToCamel<ICategory[]>(data?.data),
    });

    return { data, isLoading, isPending };
}
